import { render, staticRenderFns } from "./CreateCustomerContact.vue?vue&type=template&id=a25e995c"
import script from "./CreateCustomerContact.vue?vue&type=script&lang=js"
export * from "./CreateCustomerContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports